
import PubSub from "pubsub-js";
import { createCustomEvent } from "@wearegood/good-utilities";

///////////////
// Constants //
///////////////

const CLASS_BODY_NAV_VISIBLE = "nav_Visible";

/////////////////////////
// Classes & Functions //
/////////////////////////

/**
 * Class to manage the toggle control for display of the main navigation menu
 *
 * @export
 * @class MainNavToggle
 */
export default class MainNavToggle {
  constructor(element) {
    this.menuToggle = element;

    this.bindCustomMessageEvents();
    this.subscribeToEvents();
  }

  toggleMenu() {
    document.body.classList.toggle(CLASS_BODY_NAV_VISIBLE);
  }
  
  openMenu() {
    document.body.classList.add(CLASS_BODY_NAV_VISIBLE);
   }

  closeMenu() {
    document.body.classList.remove(CLASS_BODY_NAV_VISIBLE);
  }

  subscribeToEvents() { 
    PubSub.subscribe('mainnav/close', () => {
      this.menuToggle.dispatchEvent(createCustomEvent("closeMainNav"));
    });
  }

  /**
   * Add event handler for main navigation toggle
   * @function
   */
  bindCustomMessageEvents() {
    this.menuToggle.addEventListener("toggleMainNav", this.toggleMenu.bind(this));
    this.menuToggle.addEventListener("openMainNav", this.openMenu.bind(this));
    this.menuToggle.addEventListener("closeMainNav", this.closeMenu.bind(this));
  }
}